import React from 'react'
import { Col } from 'react-bootstrap';

const Checkbox = (props) => {
  return (
    <Col>
      <div className="switch">
        <input
          id={props.identifier}
          name={props.name}
          disabled={props.disabled}
          type="checkbox"
          value={props.value}
          className="visually-hidden"
          key={props.value}
          onChange={props.handleChange}
        />
        <label htmlFor={props.identifier} className="switch-label checkbox-label text-center">{props.label}</label>
      </div>
    </Col>
  )
}

export default Checkbox
